import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PROFILES } from "../data/profiles";

import "../css/profilePage.css";

export default function ProfilePage(){

    const { id } = useParams();

    const navigate = useNavigate();

    const profile = PROFILES.find((p)=>p._id===id);

    if(!profile){
        return <h2>Profile Not Found</h2>;
    }

    return(

        <div className="profile-page">

            <button className="back-btn" onClick={()=>navigate(-1)}>
                ← Back
            </button>

            <img src={profile.imageUrl} alt={profile.name}/>

            <h1>{profile.name}</h1>

            <h3>{profile.role}</h3>

            <p>{profile.bio}</p>

        </div>

    );

}